import React from 'react';
import './Changelog.css';

const entries = [
  {
    date: 'March 28, 2026',
    version: 'v2.4.0',
    title: 'AI Resume Tailoring',
    changes: [
      'AI now tailors your resume for each specific job posting',
      'Premium plan: up to 10 tailored resumes per day',
      'Improved cover letter tone matching',
    ],
  },
  {
    date: 'March 10, 2026',
    version: 'v2.3.0',
    title: 'Analytics Dashboard Overhaul',
    changes: [
      'New analytics dashboard with application funnel visualization',
      'Export analytics data as CSV (Pro and Premium)',
      'Track cold email open rates and reply rates',
    ],
  },
  {
    date: 'February 20, 2026',
    version: 'v2.2.0',
    title: 'Cold Email Templates',
    changes: [
      'Choose from 5 new cold email templates',
      'A/B test subject lines automatically',
      'Improved recruiter email detection',
    ],
  },
  {
    date: 'February 1, 2026',
    version: 'v2.1.0',
    title: 'Onboarding Improvements',
    changes: [
      'New guided setup wizard for first-time users',
      'Resume parsing accuracy improved by 30%',
      'Bug fixes and performance improvements',
    ],
  },
];

const Changelog = () => {
  return (
    <div className="changelog-page">
      <div className="changelog-layout">
        <div className="changelog-card">
          <div className="changelog-header">
            <h1>Changelog</h1>
          </div>
          <p className="changelog-subtitle">What's new in ApplyAI.</p>

          {entries.map((entry, index) => (
            <div key={index} className="changelog-entry">
              <div className="changelog-entry-meta">
                <span className="changelog-date">{entry.date}</span>
                <span className="changelog-version">{entry.version}</span>
              </div>
              <h2 className="changelog-entry-title">{entry.title}</h2>
              <ul className="changelog-changes">
                {entry.changes.map((change, i) => (
                  <li key={i}>{change}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Changelog;
